import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Service } from '../data/services';
interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  return <article className="flex h-full flex-col border border-slate-200 bg-white p-8" data-id="element-129" data-mp="2qmb5qf6xc52e">
      <span className="block h-px w-10 bg-gold" aria-hidden="true" data-id="element-130" data-mp="2vkmk9385z3qy" />
      <h3 className="mt-6 font-serif text-[22px] leading-snug text-navy-900" data-id="element-131" data-mp="30hcz5n88ftas">{service.title}</h3>
      <p className="mt-4 text-[15px] leading-relaxed text-ink/75" data-id="element-132" data-mp="34iy6kt1zzfdl">{service.summary}</p>
      <Link to={`/services/${service.slug}`} className="mt-auto flex items-center gap-2 pt-8 text-[14px] font-medium text-navy-900 transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-133" data-mp="39ag75g03zdy1">
        Learn More
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="3jagr945sxy3a" />
      </Link>
    </article>;
}